import { render, staticRenderFns } from "./BasketItem.vue?vue&type=template&id=bd1a89bc"
import script from "./BasketItem.vue?vue&type=script&lang=js"
export * from "./BasketItem.vue?vue&type=script&lang=js"
import style0 from "./BasketItem.vue?vue&type=style&index=0&id=bd1a89bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports